import { Component, OnInit, Output, EventEmitter, Input, HostListener} from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { LookupItem } from 'src/app/shared/lookup-item.model';
import { PelagicGear } from 'src/app/shared/pelagic-gear.model';
import { lookupItemValidator } from 'src/app/shared/trip-validator.model';

/**
 * Pelagic form to display in gear-select-dialog
 */
@Component({
    selector: 'app-pelagic-form',
    templateUrl: './pelagic-form.component.html',
    styleUrls: ['./pelagic-form.component.css'],
    standalone: false
})
export class PelagicFormComponent implements OnInit {

  // back to gear type
  @Output() cancelEvent: EventEmitter<string> = new EventEmitter<string>();

  @Output() gearAddEvent = new EventEmitter<PelagicGear>();

  /* Form Controls */
  pelForm = new FormGroup({
    name: new FormControl(''),
    pelagicType: new FormControl(new LookupItem(''), [Validators.required, lookupItemValidator()]),
    totalRods: new FormControl('', [Validators.required]),
    numHooksPerRod: new FormControl('', [Validators.required]),
    isNTRCA: new FormControl(false, [Validators.required])
  });

  @Input() pel: PelagicGear = new PelagicGear();

  @Input() types: LookupItem[] = [];

  @Input() isEdit: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key == 'Enter') this.onConfirmBtnClick()
  }

  onConfirmBtnClick() {
    if (this.pelForm.valid) {
      let form = this.pelForm.value;

      let newPel = new PelagicGear();
      //Form must be validated before this
      if (this.isEdit) newPel.identifier = form.name as string;
      newPel.gearSubtype = form.pelagicType!;
      newPel.totalNumLinesRods = Number.parseInt(form.totalRods!);
      newPel.numHooksPerLineRod = Number.parseInt(form.numHooksPerRod!);
      newPel.NT_RCA = form.isNTRCA!;

      this.gearAddEvent.emit(newPel);
    } 
    this.pelForm.markAllAsTouched();
  }


  ngOnChanges() {
    if (!this.pel.totalNumLinesRods) return;
    this.pelForm.setValue(
      {
        name: this.pel.identifier,
        pelagicType: this.pel.gearSubtype,
        totalRods: this.pel.totalNumLinesRods.toString(),
        numHooksPerRod: this.pel.numHooksPerLineRod.toString(),
        isNTRCA: this.pel.NT_RCA
      }
    );
  }

  compareFn(l1: LookupItem, l2: LookupItem): boolean {
    return l1 && l2 ? l1.code === l2.code : l1 === l2;
  }


  
  _forbidNonNumeric(control: AbstractControl) {
    control.setValue(control.value.replace(/[^0-9]/g, ''));
  }

}
